import Controller from "./basicPlan.controller";
import template from "./basicPlan.html";

const basicPlan = {
  template,
  controller: Controller,
};

export default basicPlan;



// WEBPACK FOOTER //
// ./src/pages/basicPlan/basicPlan.component.js